import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCart } from '../context/CartContext'
import { useTelegram } from '../context/TelegramContext'
import Header from '../components/Header'
import './Profile.css'

function Profile() {
  const navigate = useNavigate()
  const { cart, getCartTotal, clearCart, hapticFeedback } = useCart()
  const { user, showAlert } = useTelegram()
  
  const [formData, setFormData] = useState({
    email: '',
    saveData: false,
    promoCode: '',
    agreeToTerms: false
  })

  const [loading, setLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
  }

  const handleSubmitOrder = async () => {
    if (!formData.agreeToTerms) {
      showAlert('Пожалуйста, согласитесь с условиями')
      return
    }

    if (cart.length === 0) {
      showAlert('Корзина пуста')
      return
    }

    hapticFeedback('medium')
    setLoading(true)

    try {
      // Здесь будет логика оформления заказа через API
      // Для примера переходим на страницу checkout
      navigate('/checkout')
    } catch (error) {
      showAlert('Ошибка оформления заказа')
    } finally {
      setLoading(false)
    }
  }

  const handleApplyPromo = () => {
    if (formData.promoCode) {
      hapticFeedback('light')
      // Здесь будет логика применения промокода
      showAlert('Промокод будет применен при оформлении')
    }
  }

  return (
    <div className="profile-page">
      <Header title="Оформление заказа" showBack={true} showProfile={false} />
      
      <div className="profile-content">
        {/* Выбранные товары */}
        <div className="order-summary">
          <h3 className="section-title">Выбранные товары:</h3>
          {cart.length === 0 ? (
            <div className="empty-cart-message">
              <p>Корзина пуста</p>
              <button className="btn btn-secondary" onClick={() => navigate('/')}>
                Перейти в каталог
              </button>
            </div>
          ) : (
            <div className="cart-summary">
              {cart.map((item, index) => (
                <div key={`${item.product_id}-${index}`} className="summary-item">
                  <span className="item-name">{item.product?.name || 'Товар'}</span>
                  <span className="item-details">
                    {item.quantity} × {item.product?.price || 0} ₽
                  </span>
                </div>
              ))}
              <div className="total-row">
                <span className="total-label">Итого:</span>
                <span className="total-amount">{getCartTotal().toFixed(2)} ₽</span>
              </div>
            </div>
          )}
        </div>


        {/* Email для чека */}
        <div className="form-section">
          <label htmlFor="email" className="form-label">
            Введите E-mail для чека
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className="form-input"
            placeholder="example@mail.com"
            value={formData.email}
            onChange={handleInputChange}
          />
          <div className="form-checkbox">
            <input
              type="checkbox"
              id="saveData"
              name="saveData"
              checked={formData.saveData}
              onChange={handleInputChange}
            />
            <label htmlFor="saveData">
              Запомнить данные для следующих заказов
            </label>
          </div>
        </div>

        {/* Промокод */}
        <div className="promo-section">
          <div className="promo-input-wrapper">
            <input
              type="text"
              name="promoCode"
              className="promo-input"
              placeholder="Введите промокод"
              value={formData.promoCode}
              onChange={handleInputChange}
            />
            <button className="promo-btn" onClick={handleApplyPromo}>
              →
            </button>
          </div>
        </div>

        {/* Согласие с условиями */}
        <div className="terms-section">
          <div className="form-checkbox">
            <input
              type="checkbox"
              id="agreeToTerms"
              name="agreeToTerms"
              checked={formData.agreeToTerms}
              onChange={handleInputChange}
            />
            <label htmlFor="agreeToTerms">
              Согласен с условиями{' '}
              <a href="#" className="terms-link">
                Пользовательского соглашения
              </a>
              {' '}и{' '}
              <a href="#" className="terms-link">
                Политикой конфиденциальности
              </a>
            </label>
          </div>
        </div>

        {/* Кнопка оформления */}
        <button 
          className={`btn btn-primary btn-submit ${!formData.agreeToTerms || cart.length === 0 ? 'disabled' : ''}`}
          onClick={handleSubmitOrder}
          disabled={!formData.agreeToTerms || cart.length === 0 || loading}
        >
          {loading ? 'Оформление...' : 'Оформить заказ'}
        </button>

        {/* Информация о боте */}
        {user && (
          <div className="bot-info">
            <p>@meta_wer_shop_bot</p>
            <p className="user-info">Пользователь: {user.first_name} {user.last_name || ''}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Profile
